<template>
	<span v-if="visible" class="action-button" :key="busy">
		<span v-if="busy">
			<v-tooltip left>
				<template v-slot:activator="{ on }">
					<v-progress-circular
						indeterminate
						:color="busySpinnerColor"
						:size="$vuetify.breakpoint.mdanddown ? minSize : maxSize"
						:width="3">
						<v-icon :color="busyIconColor" v-on="on" :size="$vuetify.breakpoint.mdanddown ? minSize - 4 : maxSize - 4">
							{{ icon }}
						</v-icon>
					</v-progress-circular>
				</template>
				<span>{{ $t(action) }}, {{ $t('please-wait') }}...</span>
			</v-tooltip>
		</span>

		<span v-else>
			<v-tooltip left>
				<template v-slot:activator="{ on }">
					<v-icon
						:color="color"
						v-on="on"
						:size="$vuetify.breakpoint.mdanddown ? minSize : maxSize"
						@click.stop="$emit('clicked')">
						{{ icon }}
					</v-icon>
				</template>
				<span>{{ $t(tooltip) }}</span>
			</v-tooltip>
		</span>
	</span>
</template>

<script>
export default {
	name: 'ActionButton',
	props: {
		busy: {
			type: Boolean,
			default: false,
		},
		visible: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		disabledTooltip: {
			type: String,
			default: 'action-button-disabled-tooltip',
		},
		icon: {
			type: String,
			default: 'mdi-circle',
		},
		color: {
			type: String,
			default: 'primary',
		},
		busyIconColor: {
			type: String,
			default: '#a9a9a9',
		},
		busySpinnerColor: {
			type: String,
			default: 'green',
		},
		tooltip: {
			type: String,
			default: 'action-button-tooltip',
		},
		action: {
			type: String,
			default: 'working',
		},
		minSize: {
			type: Number,
			default: 19,
		},
		maxSize: {
			type: Number,
			default: 22,
		},
	},
};
</script>
